import { brand } from '../theme'
import { TENANT } from '../tenant'

// The round accent disc with the tenant's brand glyph. Faithful to the brand
// (accent disc, white letter) but built in SVG so it ships without an asset.
// SEAM: drop a real tenant SVG into src/assets and swap the body for an <img>.
export function PMark({ size = 34 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label={TENANT.productName}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <circle cx="50" cy="50" r="50" fill={brand.teal} />
      <text
        x="50"
        y="50"
        dy="0.34em"
        textAnchor="middle"
        fontFamily={brand.font}
        fontWeight={600}
        fontSize="58"
        fill="#ffffff"
      >
        {TENANT.logoLetter}
      </text>
    </svg>
  )
}

export function Wordmark() {
  return (
    <span
      style={{
        fontWeight: 600,
        fontSize: 19,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ color: brand.teal }}>{TENANT.wordmark.lead}</span>
      <span style={{ color: brand.ink }}>{TENANT.wordmark.rest}</span>
      {TENANT.wordmark.tagline && (
        <span style={{ color: brand.greyText, fontWeight: 400, marginLeft: 8 }}>
          {TENANT.wordmark.tagline}
        </span>
      )}
    </span>
  )
}
